import { SharedSettings } from 'shared';

export const environment: SharedSettings & {
    ids: { [key: string]: string };
} = {
    isProduction: false,
    buildNumber: '20260731.2',

    appInsightsKey: '9c4d773d-7ac4-405f-9ff1-69ecaa454609',

    authAuthority: 'https://login.microsoftonline.com/80b522f3-5ca0-44ab-88f7-03366fc716bb/',
    authClientId: '7a99e771-22ee-4f47-a910-3530cbc042e7',
    authScopes: ['api://ff71a201-5b5a-4648-b602-7f334021008e/api_access', 'email', 'profile'],

    apiBaseUrl: 'https://propak-vision-services-inventory.azurewebsites.net/api/',
    hubsBaseUrl: 'https://propak-vision-services-inventory.azurewebsites.net/hubs/',
    oidenBaseUrl: 'https://oiden-test-wr49mz.azurewebsites.net',

    validAccountDomains: ['propak.com', 'plasolutions.com', 'plofa.com', 'plofa.onmicrosoft.com'],

    ids: {
        ChepCustomerAccountNumber: 'CHEP001',
        ChepShippingAccountNumber: 'CHEPSHIP',
        PimsReportName: 'Comparison PIMS',
        TowerReportName: 'Comparison Tower',
        MaterialsReportName: 'Comparison Chep Materials',
    },

    features: {
        navinvoicetrigger: true
    },

    fallbackTimeZone: 'America/Chicago',
};
